<template>
  <div class="shop-details">
    <div class="self-table">
      <div class="table-title"><span>课时包统计</span>（统计单位：天）</div>
      <div class="table-content">
        <table>
          <thead>
            <tr>
              <td />
              <td>常规体验</td>
              <td>假期体验</td>
              <td>常规周末体验</td>
              <td>假期周末体验</td>
              <td>常规日</td>
              <td>常规周</td>
              <td>常规月</td>
              <td>假期日</td>
              <td>假期周</td>
              <td>假期月</td>
              <td>常规周末日扣</td>
              <td>假期周末日扣</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>总剩余课时</td>
              <td>{{ dataInfo.taste }}</td>
              <td>{{ dataInfo.taste_holiday }}</td>
              <td>{{ dataInfo.weekend_taste }}</td>
              <td>{{ dataInfo.weekend_taste_holiday }}</td>
              <td>
                {{ dataInfo.formal_time }}（含赠送：{{
                  dataInfo.formal_time_give
                }}）
              </td>
              <td>
                {{ dataInfo.week_days }}（含赠送：{{
                  dataInfo.week_give_days
                }}）
              </td>
              <td>
                {{ dataInfo.formal_month }}（含赠送：{{
                  dataInfo.formal_month_give
                }}）
              </td>
              <td>
                {{ dataInfo.holiday_time }}（含赠送：{{
                  dataInfo.holiday_time_give
                }}）
              </td>
              <td>
                {{ dataInfo.holiday_week_days }}（含赠送：{{
                  dataInfo.holiday_week_give_days
                }}）
              </td>
              <td>
                {{ dataInfo.holiday_month }}（含赠送：{{
                  dataInfo.holiday_month_give
                }}）
              </td>
              <td>
                {{ dataInfo.formail_weekend_day }}（含赠送：{{
                  dataInfo.formail_weekend_give_day
                }}）
              </td>
              <td>
                {{ dataInfo.holiday_weekend_day }}（含赠送：{{
                  dataInfo.holiday_weekend_give_day
                }}）
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="self-table">
      <div class="table-title"><span>出勤&课耗统计</span>（统计单位：天）</div>
      <div class="table-content">
        <table>
          <thead>
            <tr>
              <td />
              <td>已出勤天数</td>
              <td>已消耗课时</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>共计</td>
              <td>{{ dataInfo.sign_num }}</td>
              <td>{{ dataInfo.consume_days }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="self-table">
      <div class="table-title"><span>历史小结统计</span>（统计单位：条）</div>
      <div class="table-content">
        <table>
          <thead>
            <tr>
              <td />
              <td>共计</td>
              <td>满意</td>
              <td>不满意</td>
              <td>未评分</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>小结数量</td>
              <td>{{ dataInfo.total_report_num }}</td>
              <td>{{ dataInfo.satisfaction_report_num }}</td>
              <td>{{ dataInfo.dissatisfaction_report_num }}</td>
              <td>{{ dataInfo.null_report_num }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="self-table">
      <div class="table-title"><span>回访记录统计</span>（统计单位：条）</div>
      <div class="table-content">
        <table>
          <thead>
            <tr>
              <td />
              <td>回访记录</td>
              <td>家长会记录</td>
              <td>退费/结果记录</td>
              <td>其他记录</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>共计</td>
              <td>{{ dataInfo.visit_1_num }}</td>
              <td>{{ dataInfo.visit_2_num }}</td>
              <td>{{ dataInfo.visit_3_num }}</td>
              <td>{{ dataInfo.visit_4_num }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopDetails',
  components: {},
  data() {
    return {
      dataInfo: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const child_id = this.$route.query.child_id
    this.getInfoAttend(child_id)
  },
  methods: {
    async getInfoAttend(child_id) {
      const ret = await this.$http.getInfoAttend({ child_id })
      if (ret.code == 200) {
        this.dataInfo = ret.data
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
